export default __webpack_public_path__ + "static/media/logo-udd-blanco.72221696.svg";